import AndroidIcon from "../static/images/androidPlayIcon.png";
import BodyDescriptionCard from "./BodyDescriptionCard";
import UpcomingEvents from "./UpcomingEvents.jsx";
import React, { useState, useEffect } from "react";
import { fetchUpcomingEvents } from "../../../firebase/events";
import {
  APPLE_STORE_DOWNLOAD_LINK,
  GPLAY_DOWNLOAD_LINK,
} from "../../../utils/consts";
import musicPoster from "../static/images/LiveMusicPoster.png";
import { Helmet } from "react-helmet";

function Body() {
  const [eventsList, seteventsList] = useState([]);

  const [eventCount, seteventCount] = useState(5);

  useEffect(() => {
    if (!eventCount) return;
    fetchUpcomingEvents(eventCount)
      .then((data) => {
        console.log(data,"!!!!!!!!!!!!!!!!!!!!")
        seteventsList(data)})
      .catch((err)=>{console.log(err)
      alert(err);
      });
  }, [eventCount]);

  return (
    <div className="homepageBody">
      <Helmet>
        <title>Live Ombre | Discover live streamed music events from around the world.</title>
      </Helmet>
      <div className="liveMusicPoster ml-xl-6 ml-lg-6 ml-md-6">
        <div className="posterText col-xl-7 col-lg-7 col-md-7 col-sm-7 col-8">
          Experience Live Music
        </div>
        <div className="posterDescription col-8">
          Discover the Live Streams of Artists you Love
          <br />
          Join music festivals from anywhere.
        </div>
        <div className="d-flex flex-row downloadButtonsContainer mt-lg-4 mt-md-3 mt-sm-5 mt-xl-7 pb-xl-5 pb-lg-5 pb-md-3 pb-sm-3 pb-3  pl-sm-2 pl-2">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={GPLAY_DOWNLOAD_LINK}
            className="anchor"
          >
            <div className="androidButton bg-white d-flex flex-row px-xl-4 px-lg-4 px-md-3 px-sm-4 px-3 py-2 mr-4">
              <img
                className="downloadIcon"
                src={AndroidIcon}
                alt="Android Play Icon"
              />
              <div className="androidButtonText ml-sm-2 ml-2 my-auto">
                Android
              </div>
            </div>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={APPLE_STORE_DOWNLOAD_LINK}
            className="anchor"
          >
            <div className="iosButton d-flex flex-row bg-white px-xl-4 px-lg-4 px-md-3 px-sm-4 px-3 py-2">
              <i className="fab fa-apple appleIcon"></i>
              <div className="iosButtonText my-auto ml-lg-3 ml-lg-3 ml-md-3 ml-sm-2 ml-2">
                iOS
              </div>
            </div>
          </a>
        </div>
      </div>

      <div className="listenToText col-xl-8 col-lg-8 col-md-8 col-sm-7 col-8">
        Listen to the Finest Music globally
      </div>
      <div className="d-flex mt-5 mb-sm-2 mb-2">
        <div className="col-7 upcomingEventsTitle pl-xl-0 pl-lg-0 pl-md-0 pl-sm-3 pl-3">
          UPCOMING SHOWS
        </div>
      </div>

      <UpcomingEvents eventsList={eventsList} />

      <BodyDescriptionCard />
    </div>
  );
}

export default Body;



// WEBPACK FOOTER //
// ./src/pages/Home/components/Body.jsx